import { useCallback, useMemo, useRef } from "react";

export default function useDetailsPanelAnchor() {
  const containerRef = useRef(null);

  // Details always open at the top of the table. Keep this callback in the
  // shared hook API so existing row-click handlers do not need special cases.
  const anchorToRow = useCallback(() => {}, []);

  const resetAnchor = useCallback(() => {}, []);

  const anchorStyle = useMemo(
    () => ({
      "--transaction-details-anchor-top": "0px",
    }),
    [],
  );

  return {
    anchorStyle,
    anchorToRow,
    containerRef,
    resetAnchor,
  };
}
